import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-approve-final-cost-success',
  templateUrl: './approve-final-cost-success.component.html',
  styleUrl: './approve-final-cost-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApproveFinalCostSuccessComponent {
  readonly message = input.required<string>();
}
